import { Dialog, Button, Input, Stack, Text } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { apiPost, apiPut } from '../api';

const AddClientModal = ({ isOpen, onClose, onSuccess, editClient }) => {
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      if (editClient) {
        setName(editClient.name || '');
        setContact(editClient.contact || '');
      } else {
        setName('');
        setContact('');
      }
      setError('');
    }
  }, [isOpen, editClient]);

  const handleSave = async () => {
    if (!name.trim()) {
      setError('Client name is required');
      return;
    }
    setSaving(true);
    setError('');
    try {
      if (editClient) {
        await apiPut(`/clients/${editClient._id}`, { name: name.trim(), contact: contact.trim() });
        onSuccess(null, true); // null client, isEdit=true
      } else {
        const res = await apiPost('/clients', { name: name.trim(), contact: contact.trim() });
        onSuccess(res.client, false); // new client, isEdit=false
      }
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to save client');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(e) => { if (!e.open) onClose(); }}
      size="sm"
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header>
            <Dialog.Title>{editClient ? 'Edit Client' : 'Add New Client'}</Dialog.Title>
            <Dialog.CloseTrigger onClick={onClose} />
          </Dialog.Header>
          <Dialog.Body>
            <Stack spacing={3}>
              {error && <Text color="red.500" fontSize="sm">{error}</Text>}
              <div>
                <Text fontSize="sm" mb={1}>Client Name *</Text>
                <Input
                  placeholder="Enter client name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoFocus
                />
              </div>
              <div>
                <Text fontSize="sm" mb={1}>Contact Number</Text>
                <Input
                  placeholder="Enter contact number (optional)"
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                />
              </div>
            </Stack>
          </Dialog.Body>
          <Dialog.Footer>
            <Button variant="ghost" mr={3} onClick={onClose}>Cancel</Button>
            <Button colorScheme="blue" onClick={handleSave} isLoading={saving}>
              {editClient ? 'Update' : 'Save'}
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default AddClientModal;
